import { leadToAppointment } from "api/Leads"
import { useMutation, useQueryClient } from "react-query"
import { toast } from "react-toastify"



export const useLeadToAppointment = () => {
    const queryClient = useQueryClient();
    return useMutation(leadToAppointment, {
        onSuccess: () => {
            queryClient.invalidateQueries('leads')
            toast.success('Lead to Appointment successfully transfered')
        },
        onError: (error) => {
            
            
            toast.error('Somethng went wrong')
        }
    })
}